import { render, staticRenderFns } from "./OnboardingImageSection.vue?vue&type=template&id=71410714"
import script from "./OnboardingImageSection.vue?vue&type=script&lang=js"
export * from "./OnboardingImageSection.vue?vue&type=script&lang=js"
import style0 from "./OnboardingImageSection.vue?vue&type=style&index=0&id=71410714&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports